/**  Polyfill for IE11 support */

/** IMPORTANT: Check if method exists. If not, implement it. */

/** The purpose of checking is to avoid trying to override the native code. */

/** If you want to add polyfills, check the https://developer.mozilla.org
 * implementation of the wanted function, under the "Polyfill" section.
 * (i.e. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find#Polyfill)
 */
// Polyfill for Array.find
if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    value: function value(predicate) {
      if (this == null) throw new TypeError('"this" is null or not defined');
      var o = Object(this);
      var len = o.length >>> 0;
      if (typeof predicate !== 'function') throw new TypeError('predicate must be a function');
      var thisArg = arguments[1];
      var k = 0;

      while (k < len) {
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) return kValue;
        k++;
      }

      return undefined;
    },
    configurable: true,
    writable: true
  });
} // Polyfill for Array.flatMap


if (!Array.prototype.flatMap) {
  var concat = function concat(x, y) {
    return x.concat(y);
  };

  var flatMap = function flatMap(f, xs) {
    return xs.map(f).reduce(concat, []);
  };

  Array.prototype.flatMap = function (f) {
    return flatMap(f, this);
  };
} // Polyfill for str.startsWith


if (!String.prototype.startsWith) {
  String.prototype.startsWith = function (search, pos) {
    return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
  };
}